import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import styles from './PlanLoaderSlideV11.css';

const TICK_DURATION = 100;
const FINISH_DELAY = 800;
const RADIUS = 50;

function PlanLoaderSlideV11({ onContinue, steps }) {
    const [progress, setProgress] = useState(0);

    useEffect(() => {
        if (progress === 100) {
            const timer = setTimeout(onContinue, FINISH_DELAY);

            return () => clearTimeout(timer);
        }

        const timer = setTimeout(() => setProgress(prev => prev + 1), TICK_DURATION);

        return () => clearTimeout(timer);
    }, [progress]);

    const stepIndex = Math.max(0, Math.ceil(progress * steps.length / 100) - 1);

    return (
        <section className={styles.root}>
            <div className={styles.ring}>
                <svg
                    width='116' height='116' viewBox='0 0 116 116'
                    className={styles.svg} aria-hidden='true'
                >
                    <circle
                        cx='58' cy='58' r={RADIUS}
                        className={styles.track}
                    />
                    <circle
                        cx='58'
                        cy='58'
                        r={RADIUS}
                        className={styles.fill}
                        pathLength='100'
                        strokeDasharray={`${progress} 100`}
                        transform='rotate(-90 58 58)'
                    />
                </svg>
                <p className={styles.percent}>
                    <span className={styles.percentValue}>{progress}%</span>
                </p>
            </div>
            <h1 className={styles.caption} aria-live='polite'>{steps[stepIndex]}</h1>
        </section>
    );
}

PlanLoaderSlideV11.propTypes = {
    onContinue: PropTypes.func.isRequired,
    steps: PropTypes.arrayOf(PropTypes.string).isRequired
};

export {
    PlanLoaderSlideV11
};
